import * as THREE from "three";


const getMaterialTexture = (path = null, model = false, land = false) => {

    let material = null;

    const textureLoader = new THREE.TextureLoader();

    if (model) {
        material = new THREE.MeshPhysicalMaterial({
            clearcoat: 0.5,
            flatShading: true,
            roughness: 0.2,
            metalness: 0.7,
            depthTest: true,
            depthWrite: true,
            reflectivity: 0.9,
            side: THREE.DoubleSide,
        });
    } else {
        material = new THREE.MeshStandardMaterial({
            side: THREE.DoubleSide,
        })
    }

    if (path) {
        const texture = textureLoader.load(path)
        const rotateTexture = new THREE.Vector2(0, 0)
        texture.center.set(0, 0);
        // texture.rotation = rotateTexture;
        // texture.matrix.rotate(rotateTexture);

        if (land) {
            texture.repeat.set(3, 3);
            texture.wrapS = THREE.RepeatWrapping
            texture.wrapT = THREE.RepeatWrapping
        }

        material.map = texture;
    } else if (!model) {
        material.color = new THREE.Color('#aeaece');
    }

    return material;
}
export default getMaterialTexture;
